import React from "react";
import type { FC, PropsWithChildren } from 'react';

import './Modal.css';

type ModalProps = PropsWithChildren<{
  show?: boolean;
  style?: React.CSSProperties;
  modalClassName?:string;
 modalStyle?:React.CSSProperties
}>;

const Modal: FC<ModalProps> = props => {
  if (!props.show) {
    return null;
  }

  return (
    <div className='modalContainer' style={props.modalStyle}>
      <div  id='modal' style={props.style} className={`${props.modalClassName || ''} modal`} >
        {props.children}
      </div>
    </div>
  );
};

export default Modal;
